module.exports = __webpack_public_path__ + "static/barcelona_code_school_campus_-2-521d064139f3ab72523f1bd364b1f565.jpg";